import styled from 'styled-components';

import PrimaryButtonLoading from '../../shared/buttons/loadingButtons/PrimaryButtonLoading';
import SecondaryButton from '../../shared/buttons/basicButtons/SecondaryButton.sc';

export const TokenErrorContainer = styled.div`
  text-align: center;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.white.a10};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ToHomeBtn = styled(SecondaryButton)`
  width: 100%;
  min-width: auto;
  height: 50px;
  font-size: 1rem;
  margin-top: 30px;
`;

export const SecurityBlocksContainer = styled.div`
  display: flex;
  height: 0.1rem;
  margin-bottom: 1.4rem;
`;

export const SecurityBlock = styled.div`
  width: 65.8px;
  height: 2px;
  background-color: ${props => props.color};
  margin-left: 0.5rem;

  &:first-child {
    margin-left: 0;
  }
`;

export const SubmitBtn = styled(PrimaryButtonLoading)`
  width: 100%;
  height: 50px;
  margin-top: 40px;
  min-width: auto;
`;
